import React, { useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";

// import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import {
    NotificacionToastDeCreacion,
    // NotificacionToastDeError,
} from "../../isp._comun/iu/componentes/widgets/notificacionesToast/NotificacionesToast";

import * as TipoDeError from "../../isp._comun/services/Errores";

import DataDeRespuestas_Facturacion from "./layouts/DataEstaticaDeRespuestas.json";

import ZonaReducer from "../reductores/ZonaReducer";
import * as Action from "../reductores/acciones/dispatch/_ActionsDispatch";
import CargaDeZonaConsultado from "../reductores/acciones/dispatch/CargaDeZonaConsultado";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";

import DialogoZonaLayout from "./layouts/DialogoZonaLayout";
// import { TipoDeZona } from "../../reductores/Constantes";

import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";

// import ServicioRegistroDeZona from "../../servicios/ServicioRegistroDeZona";
//import ServicioDeActualizacionDeZona from "../../servicios/ServicioDeActualizacionDeZona";
//import ServicioDeQueryDeUnZona from "../../servicios/ServicioDeQueryDeUnZona";

// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../all/presentadores/DataEstaticaDeRespuestas.json";
// import { ModosOp } from "../../../_comun/Constantes";

const DialogoZona = ({ ventana }) => {
    const {
        // estadoPrin,
        // dispatchPrincipal,
        // cargarPantallaLogin,
        handleErroresExtraEnPrincipal,
        notificar,
    } = useContext(GlobalContext);

    const [estadoDCF, dispatchDCF] = useReducer(ZonaReducer, ventana.estadoComp);
    ventana.estadoComp = estadoDCF;

    // const registrarZonaCommand = new ComandoRegistrarZona();
    const registrarZonaCommand = new ComandoAPI();
    // registrarZonaCommand.ejecutar = useHandlerDeComandoConSesionActiva(async () => {
    registrarZonaCommand.ejecutar = async () => {
        const zona = {
            tipoZona: estadoDCF.domain.screen.tipoZona,
            nombre: estadoDCF.domain.screen.nombre,
            descripcion: estadoDCF.domain.screen.descripcion,
            precio: estadoDCF.domain.screen.precio,
            moneda: estadoDCF.domain.screen.moneda,
            udm: estadoDCF.domain.screen.udm,
        };

        try {
            // const servicio = new ServicioRegistroDeZona();
            // registrarZonaCommand.servicio = servicio;

            // const dataRegistradaDeZona = await servicio.ejecutar(zona);
            const dataRegistradaDeZona = await registrarZonaCommand.servicio.ejecutar(zona);
            // await new ServicioRegistroDeClienteAFacturar().ejecutar(zona);
            dispatchDCF(new Action.CargaDeZonaRegistrado(dataRegistradaDeZona));
            notificar(
                new NotificacionToastDeCreacion(
                    DataDeRespuestas_Facturacion.CreacionClienteAFacturar.titulo,
                    DataDeRespuestas_Facturacion.CreacionClienteAFacturar.mensaje,
                    dataRegistradaDeZona.idZona
                )
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlCrearZona(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    const actualizarZonaCommand = new ComandoAPI();
    actualizarZonaCommand.ejecutar = async () => {
        const zonaPorActualizar = {
            id: estadoDCF.domain.screen.idZona,
            data: estadoDCF.domain.update,
        };

        try {
            // const servicio = new ServicioDeActualizacionDeZona();
            // actualizarZonaCommand.servicio = servicio;
            // const dataDeClienteActualizado =
            await actualizarZonaCommand.servicio.ejecutar(zonaPorActualizar);
            dispatchDCF(
                new Action.CargaDeZonaActualizado()
                // new Action.CargaDeClienteActualizado(dataDeClienteActualizado)
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchDCF(new Action.CargaDeErroresDelDominioAlActualizarZona(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                    /* new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError +
                            CodigoDeError[nombreDeError] +
                            "\n" +
                            DataDeRespuestas_Comun[nombreDeError].descripcion
                    ) */
                /*); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    const buscarUnSoloZonaCommand = new ComandoAPI();
    // buscarUnSoloZonaCommand.ejecutar = useHandlerDeComandoConSesionActiva(async (idZona) => {
    buscarUnSoloZonaCommand.ejecutar = async (idZona) => {
        try {
            // const servicio = new ServicioDeQueryDeUnZona();
            // buscarUnSoloZonaCommand.servicio = servicio;
            const respuestaQuery = await buscarUnSoloZonaCommand.servicio.ejecutar(idZona);
            dispatchDCF(new CargaDeZonaConsultado(respuestaQuery.zona));
            // ventana.ventanaCargando.dispatch(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    return (
        <DialogoZonaLayout
            ventana={ventana}
            estadoDCF={estadoDCF}
            dispatchDCF={dispatchDCF}
            // registrarClienteAFacturar={useHandlerDeServicio(registrarClienteAFacturar)}
            registrarZonaCommand={registrarZonaCommand}
            // actualizarClienteAFacturar={useHandlerDeServicio(actualizarClienteAFacturar)}
            actualizarZonaCommand={actualizarZonaCommand}
            // buscarUnSoloClienteAFacturar={buscarUnSoloClienteAFacturar}
            buscarUnSoloZonaCommand={buscarUnSoloZonaCommand}
        />
    );
};

export default DialogoZona;
